import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { environment } from '@environments/environment';
import { GlobalFunctions } from '@global/GlobalFunctions';

/** UpdateService */
@Injectable({ providedIn: 'root' })
export class UpdateService {

	private localDev = environment.localsite; // or use your environment flag

	/** checkInterval */
	private checkInterval = environment.production ? 600000 : 60000; // 10 minutes in production, 1 minute in development

	/** updateAvailable$ */
	public updateAvailable$ = new BehaviorSubject(false);

	/**
	 * constructor
	 * @param updates 
	 */
	constructor(
		private updates: SwUpdate,
		private globalFunctions: GlobalFunctions) {

		// console.log(`${this.constructor.name} => updates.isEnabled = ${updates.isEnabled}, dev = ${dev}`);
		if (!this.localDev && updates.isEnabled) {
			// Only check and subscribe in production
			setInterval(async () => {
				try {
					// // console.log(`${this.constructor.name} => await this.updates.checkForUpdate()`);
					await this.updates.checkForUpdate();
				} catch (e) {
					// console.error('Update check failed', e);
				}
			}, this.checkInterval);

			updates.versionUpdates.subscribe(event => {
				// // console.log(`${this.constructor.name} => updates.versionUpdates.subscribe: event.type = ${event.type}`);
				if (event.type === 'VERSION_READY') {
					this.updateAvailable$.next(true);
				}
			});
		}
	}

	/**
	 * activateUpdate
	 * @returns 
	 */
	public async activateUpdate(): Promise<boolean> {

		const okResult = await firstValueFrom(
			this.globalFunctions.UserConfirm$('Install new application version?', 'Upgrade Application')
		);

		if (!okResult) {
			this.globalFunctions.DisplaySnackBar({ message: "Update Canceled", duration: 1000 })
			return false;
		}

		await this.updates.activateUpdate();
		document.location.reload();

		return true; // technically never reached after reload, but correct signature

	}

	/**
	 * updateNow
	 * @returns 
	 */
	public async updateNow(): Promise<boolean> {

		await this.updates.activateUpdate();

		this.globalFunctions.DisplaySnackBar({
			message: "Application has been updated.",
			duration: 2000,
			action: ""
		});
		
		document.location.reload();

		return true; // technically never reached after reload, but correct signature
	}
}